import axios from 'axios';
import { API_ADDRESS } from 'constants/server';

/* global InferenceApiBody, InferenceData */

export async function fetchInference(body: InferenceApiBody): Promise<InferenceData> {
  const response = await axios.post(`${API_ADDRESS}/inference`, body);
  return response.data.output[1];
}
